import { styled } from '@mui/material';
import { GeneralInformation } from 'components/CourseSetup';
import { useViewport } from 'contexts/viewport';
import { PageContext } from 'pages/CourseSetup/PageProvider';
import { useContext } from 'react';
import { Box, Container } from 'shell/components';

const Tablet = () => {
    const { device } = useViewport();
    const { form, errors, handleChange, handleClose, submitData } = useContext(PageContext);
    return (
        <BackgroundBox>
            <CourseSetUpContainer device={device}>
                <CenterBox>
                    <GeneralInformation
                        isLti={process.env.REACT_APP_AUTH === 'LTI'}
                        form={form}
                        errors={errors}
                        handleChange={handleChange}
                        handleClose={handleClose}
                        handleSubmit={submitData}
                    />
                </CenterBox>
            </CourseSetUpContainer>
        </BackgroundBox>
    );
};

const BackgroundBox = styled(Box)(() => {
    return {
        width: '100vw',
        height: '100%',
    };
});

const CourseSetUpContainer = styled(Container)(({ theme }) => {
    return {
        padding: theme.spacing(20, 0, 10, 0),
        width: '100%',
        background: theme.palette.ensightful.shades[0],
    };
});

const CenterBox = styled(Box)(() => {
    return {
        minWidth: 450,
        width: 'fit-content',
        minHeight: '100%',
    };
});
export default Tablet;
